export default {
    reports_analytics: "التقارير والتحليلات",
total_revenue: "إجمالي الإيرادات",
total_orders: "إجمالي الطلبات",
products_sold: "عدد المنتجات المباعة",
low_stock_items: "منتجات منخفضة المخزون",
products: "منتجات",
units: "وحدة",
currency: "ر.ق",

top_selling_products: "أفضل المنتجات مبيعًا",
product: "المنتج",
sold_qty: "الكمية المباعة",
revenue: "الإيرادات",
no_sales_data: "لا توجد بيانات مبيعات",

reports: "التقارير",
select_report_module: "اختر نوع التقرير",

inventory_report: "تقرير المخزون",
inventory_desc: "المخزون وتاريخ الانتهاء والتوفر",

product_report: "تقرير المنتجات",
product_desc: "بيانات المنتجات والحالة",

order_report: "تقرير الطلبات",
order_desc: "الطلبات المستلمة",

invoice_report: "تقرير الفواتير",
invoice_desc: "الفواتير المُنشأة",

back_to_reports: "العودة إلى التقارير",
 productReport: "تقرير المنتجات",
      excel: "إكسل",
      pdf: "بي دي إف",
      search: "ابحث عن منتج...",
      allStatus: "كل الحالات",
      pending: "قيد الموافقة",
      approved: "تمت الموافقة",
      allStock: "كل المخزون",
      inStock: "متوفر",
      lowStock: "مخزون منخفض",
      outOfStock: "غير متوفر",
      minStock: "أدنى مخزون",
      maxStock: "أقصى مخزون",
      noProducts: "لا توجد منتجات",
      loading: "جاري التحميل...",
      prev: "السابق",
      next: "التالي",
      page: "صفحة",
      of: "من",
      table: {
    updated: "آخر تحديث",
    unit: "الوحدة",
    store: "المتجر",
    stock: "المخزون",
    shelfLife: "مدة الصلاحية",
    status: "الحالة",
    product: "المنتج",
    productId: "رقم المنتج",
    price: "السعر",
    expiryDate: "تاريخ الانتهاء",
    currency: "العملة",
    createdAt: "تاريخ الإنشاء",
    company: "الشركة",
    category: "الفئة",
    branch: "الفرع",
    productEn: "المنتج (إنجليزي)",
productAr: "المنتج (عربي)",
  },
  supinventory: {
  title: "تقرير المخزون",
  product: "المنتج",
  stock: "المخزون",
  status: "الحالة",
  expiry: "الصلاحية",
  updated: "آخر تحديث",
  allStock: "كل المخزون",
  allExpiry: "كل التواريخ",
  valid: "صالح",
  expiringSoon: "ينتهي قريباً",
  expired: "منتهي"
},
orde: {
  title: "تقرير الطلبات",
  orderId: "رقم الطلب",
  date: "التاريخ",
  status: "الحالة",
  payment: "الدفع",
  product: "المنتج",
  qty: "الكمية",
  price: "السعر",
  total: "الإجمالي",
  allProducts: "كل المنتجات",
  allStatus: "كل الحالات",
  allPayments: "كل المدفوعات"
}


}